// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-navigation-template/src/index.tsx

import baseIcon, { navigationDefaultStyleSheetGetter, defaultNavigationIconGroupProps, defaultNavigationIconShapeSize } from '@bubble-ui/temp-icon-base';
var NavigationIconGoalBetterPath = 'M23.708 7.706 26 5.414 24.586 4l-2.292 2.292-1.047-3.143-4.724 4.724 1.047 3.142-.878.878a5.704 5.704 0 1 0 1.414 1.414l.878-.877 3.143 1.047 4.724-4.724-3.143-1.047Zm-10.28.437A8.428 8.428 0 0 0 5 16.57 8.428 8.428 0 0 0 13.429 25a8.428 8.428 0 0 0 8.376-9.367l-.109-.994 1.988-.218.11.994c.041.379.063.765.063 1.156C23.857 22.331 19.19 27 13.43 27 7.669 27 3 22.33 3 16.57c0-5.76 4.669-10.428 10.429-10.428.391 0 .777.022 1.156.063l.994.11-.218 1.988-.994-.11a8.604 8.604 0 0 0-.938-.051Zm0 4.725a3.704 3.704 0 1 0 3.23 1.888l-3.23 3.23-1.414-1.415 3.23-3.229a3.687 3.687 0 0 0-1.816-.474Zm6.077-2.373-.694-2.082 1.561-1.562.695 2.082 2.082.694-1.562 1.562-2.082-.694Z';
var NavigationIconGoalBetter = baseIcon('NavigationIconGoalBetter', {
  getPath: () => NavigationIconGoalBetterPath,
  defaultStyleSheetGetter: navigationDefaultStyleSheetGetter,
  groupProps: defaultNavigationIconGroupProps,
  shapeSize: defaultNavigationIconShapeSize
});
export default NavigationIconGoalBetter;
//# sourceMappingURL=index.js.map